// import HeroSection from "../components/AboutUsComp/HeroSection";
// import AboutBusinessSection from "../components/AboutUsComp/AboutBusinessSection";
// import WhyChooseUsSection from "../components/AboutUsComp/WhyChooseUsSection";
// import About2 from "../components/AboutUsComp/About2";
// import LeadershipTeamSection from "../components/AboutUsComp/LeadershipTeamSection";

import AboutFull from "../components/AboutUsComp/AboutFull";


function AboutUs() {
  return (
    <>
      {/* <HeroSection />
      <About2 />
      <AboutBusinessSection />
      <LeadershipTeamSection />
      <WhyChooseUsSection /> */}
      <AboutFull />
    </>
  );
}

export default AboutUs;
